<template lang="pug">
.custom-confetti
 .header
    h3.title {{$t(`${BASE_TRANSLATION_PATH}.title`)}}
    .add-section
        aiq-tooltip(effect="dark",
             :content="$t(`${BASE_TRANSLATION_PATH}.add_custom_visual`)",
             placement="bottom",
             :show-after="500")
          i.el-icon-plus(@click="openEditor(null)" class="add-icon add-confetti-btn")
 aiq-table(:data="confettiList"
            class="celebration-setting-table")
            aiq-table-column(:label="$t(`${BASE_TRANSLATION_PATH}.name`)"
                label-class-name="celebration-tb-header"
                min-width="17")
                template(v-slot:default="scope")
                    span {{ scope.row.name }}

            aiq-table-column(:label="$t(`${BASE_TRANSLATION_PATH}.image`)"
                label-class-name="celebration-tb-header"
                min-width="15")
                template(v-slot:default="scope")
                    img(:src="scope.row.src" class="confetti-image")
            aiq-table-column(label-class-name="celebration-tb-header"
                min-width="2")
                template(v-slot:default="scope")
                    aiq-button(@click="deleteItem(scope.row)" link type="primary" size="small",) {{ $t('global.delete') }}
aiq-dialog.model-editor(
    :title="$t(`${BASE_TRANSLATION_PATH}.title`)"
    v-model="showEditor"
    :show-close="true")
    .field-container.full-width.is-required
      label {{ $t(`${BASE_TRANSLATION_PATH}.name`) }}
      aiq-input(v-model="selectedItem.name"
            :disabled="!isNew"
            size="small"
            :max-length="250")
    .field-container.full-width.is-required.padding-top.display-flex
      aiq-button(@click="$refs.fileInput.click()" :disabled="uploadInProgress || !isNew" type="primary" size="small") {{ $t(`${BASE_TRANSLATION_PATH}.select_img`) }}
      input(type="file" ref="fileInput" accept="image/jpg, image/jpeg, image/png, image/gif, image/svg+xml" style="display:none" @change="uploadImage($event.target.files[0])")
      div(v-if="selectedItem.src")
        img(:src="selectedItem.src" class="confetti-image")
    template(v-slot:footer)
      aiq-button(v-if="!isNew" @click="deleteItem()" type="danger" :plain="true" size="small") {{ $t(`${BASE_TRANSLATION_PATH}.delete`) }}
      aiq-button(@click="showEditor = false" type="primary" :plain="true" size="small") {{ $t('global.cancel') }}
      aiq-button(v-if="isNew" @click="updateList()" type="primary" size="small") {{ $t(`${BASE_TRANSLATION_PATH}.save`) }}
</template>
<script>
import get from 'lodash/get';
import { IMAGE_ACL_TYPES } from '@/constants';
import { hosts } from '@/config/api.routes';

export default {
  name: 'custom-confetti',
  data() {
    return {
      BASE_TRANSLATION_PATH: 'settings_tab.admin_tab.celebration.custom_confetti',
      customConfetti: 'custom_confetti',
      isNew: false,
      showEditor: false,
      selectedItem: null,
      uploadedImage: null,
      uploadUrl: `${hosts.management}files/upload`,
      uploadInProgress: false,

    };
  },
  props: {
    confettiList: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update'],
  methods: {
    openEditor(item = null) {
      if (!item) {
        this.isNew = true;
        this.selectedItem = { name: '', src: '' };
      } else {
        this.isNew = false;
        this.selectedItem = item;
      }
      this.showEditor = true;
    },
    async uploadImage(file) {
      this.uploadInProgress = true;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('acl', IMAGE_ACL_TYPES.PUBLIC);
      this.$refs.fileInput.value = '';
      try {
        const response = await this.$store.dispatch('files/upload', {
          formData,
          url: this.uploadUrl,
        });
        this.uploadInProgress = false;
        const url = get(response, 'data.url', '');
        this.selectedItem.src = url;
      } catch (error) {
        this.uploadInProgress = false;
        this.$aiq.notify.error(this.$t(`${this.BASE_TRANSLATION_PATH}.error_upload`));
        return;
      }
    },
    async confirmDelete() {
      try {
        const result = await this.$aiq.confirm(
          this.$t(`${this.BASE_TRANSLATION_PATH}.delete_confirm.title`),
          this.$t(`${this.BASE_TRANSLATION_PATH}.delete_confirm.message`),
        );
        return result;
      } catch (_error) {
        return false;
      }

    },
    async deleteItem(item) {
      const confirm = await this.confirmDelete();
      if (!confirm) return;
      this.showEditor = false;
      const index = this.confettiList.findIndex(x => x.name === item.name);
      if (index >= 0) {
        this.confettiList.splice(index, 1);
      }
      await this.updateSettings(this.confettiList);
    },
    async updateSettings(confettiList) {
      try {
        const response = await this.$store.dispatch('settings/updateSetting', {
          name: 'custom_confetti',
          payload: {list: confettiList},
        });
        const confettiListres = get(response, 'list', []);
        this.$emit('update', confettiListres);
        this.$aiq.notify.success(this.$t(`${this.BASE_TRANSLATION_PATH}.save_success`));
      } catch (error) {
        this.$aiq.notify.error(this.$t(`${this.BASE_TRANSLATION_PATH}.save_error`));
      }

    },

    async updateList() {
      if (this.selectedItem.name.trim() === '' || this.selectedItem.src.trim() === '') {
        this.$aiq.notify.error(this.$t(`${this.BASE_TRANSLATION_PATH}.error_empty`));
        return;
      }
      this.showEditor = false;
      this.confettiList.push(this.selectedItem);
      await this.updateSettings(this.confettiList);
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-confetti {
    padding-top: 15px;

    .header {
        .title {
            font-size: 16px;
            font-weight: 600;
        }
    }

    .add-celebration-btn {
        font-size: 14px;
        line-height: 14px;
        vertical-align: middle;
    }

    .lang-select {
        width: 200px;
        padding-right: 20px;
    }


    .celebration-setting-table {
        border: 1px solid #A8A9AB;
        border-radius: 2px;

        ::v-deep .celebration-tb-header {
            border-bottom: 1px solid #A8A9AB;

            .cell {
                padding: 8px;
                line-height: 18px;
                font-weight: 400;
                color: #28292C;
                background: #DDD;
            }
        }

        ::v-deep .el-table__body-wrapper {
            table.el-table__body {
                tbody {
                    tr {
                        td {
                            padding: 5px 0px;

                            .sel-occurrence {
                                max-width: 200px;
                            }

                            .sel-rank {
                                max-width: 100px;
                            }

                            .sel-visual {
                                max-width: 200px;
                            }

                            .edit-btn {
                                float: right;
                            }
                        }
                    }
                }
            }
        }
    }

}

.add-icon {
    cursor: pointer;
}

.add-section {
    float: right;
}
.confetti-image {
    max-width: 100px;
    max-height: 50px;
}
.padding-top {
    padding-top: 10px;
}
.display-flex {
    display: flex;
    align-items: center;
    gap: 10px;
}
</style>